import productDevelopmentReducer, {
  createProduct,
  updateProduct,
  deleteProduct,
  retrieveProducts,
  createProductComponent,
  updateProductComponent,
  deleteProductComponent,
  retrieveProductComponents,
  createProductComponentCatalogueItemChoice,
  updateProductComponentCatalogueItemChoice,
  deleteProductComponentCatalogueItemChoice,
  selectProductComponentCatalogueItemChoice,
  selectProductComponentCatalogueItemChoiceList,
  clearAllSelectedCatalogueItemChoices,
} from "./productDevelopment";

import supplierNetworkReducer, {
  createSupplier,
  updateSupplier,
  deleteSupplier,
  retrieveSuppliers,
  searchSuppliers,
  connectGroupSupplier,
} from "./supplierNetwork";

import productCatalogueReducer, {
  createCatalogueItem,
  updateCatalogueItem,
  deleteCatalogueItem,
  retrieveCatalogueItems,
} from "./productCatalogue";

import inventoryManagementReducer, {
  createInventoryBasket,
  retrieveInventoryBaskets,
  updateInventoryBasket,
  deleteInventoryBasket,
} from "./inventoryManagement";

import luxurySellerReducer, {
  createItemListing,
  retrieveItemListings,
  updateItemListing,
  deleteItemListing,
} from "./luxurySeller";

import luxuryCollectionReducer, {
  createCollectionItem,
  updateCollectionItem,
  deleteCollectionItem,
  retrieveCollectionItems,
} from "./luxuryCollection";

import luxuryItemListingsReducer, {
  retrieveLuxuryItemListings,
  createContactUsMessage,
  retrieveAuthenticity,
  createConsignmentRequest,
  createRemoveConsignmentRequest,
  retrieveLuxuryBrands,
  createServiceRequest,
  addToCart,
  removeFromCart,
  createOrder,
  retrievePaymentMethods,
  retrieveCustomerOrders,
  retrieveLuxuryItemListingDetails,
  createCertificateHardCopyRequest,
  submitCreditCardInfo,
  createCreditCardOrder,
} from "./luxuryItemListings";

export {
  productDevelopmentReducer,
  createProduct,
  updateProduct,
  deleteProduct,
  retrieveProducts,
  createProductComponent,
  updateProductComponent,
  deleteProductComponent,
  retrieveProductComponents,
  createProductComponentCatalogueItemChoice,
  updateProductComponentCatalogueItemChoice,
  deleteProductComponentCatalogueItemChoice,
  selectProductComponentCatalogueItemChoice,
  selectProductComponentCatalogueItemChoiceList,
  clearAllSelectedCatalogueItemChoices,
  supplierNetworkReducer,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  retrieveSuppliers,
  searchSuppliers,
  connectGroupSupplier,
  productCatalogueReducer,
  createCatalogueItem,
  updateCatalogueItem,
  deleteCatalogueItem,
  retrieveCatalogueItems,
  inventoryManagementReducer,
  createInventoryBasket,
  retrieveInventoryBaskets,
  updateInventoryBasket,
  deleteInventoryBasket,
  //// Luxurystation
  luxurySellerReducer,
  createItemListing,
  retrieveItemListings,
  updateItemListing,
  deleteItemListing,
  luxuryCollectionReducer,
  createCollectionItem,
  updateCollectionItem,
  deleteCollectionItem,
  retrieveCollectionItems,
  luxuryItemListingsReducer,
  retrieveLuxuryItemListings,
  createContactUsMessage,
  retrieveAuthenticity,
  createConsignmentRequest,
  createRemoveConsignmentRequest,
  retrieveLuxuryBrands,
  createServiceRequest,
  addToCart,
  removeFromCart,
  createOrder,
  retrievePaymentMethods,
  retrieveCustomerOrders,
  retrieveLuxuryItemListingDetails,
  createCertificateHardCopyRequest,
  submitCreditCardInfo,
  createCreditCardOrder,
};
